import {
  ConversationChannel,
  GetMultiConversationDetailsResponseDetailedConversation,
  MediaInterface,
  MessageType,
  Participant,
  ParticipantType,
  PlatformLocation,
  SendStatusInterface,
} from '@vendasta/conversation';
import { BadgeColor } from '@vendasta/galaxy/badge/src/badge.component';
import { Timestamp } from 'firebase/firestore';
export { SubjectParticipant } from '@vendasta/conversation';

export interface FirestoreConversation {
  id?: string;
  conversationId?: string;
  externalConversationId?: string;
  previewContent?: string;
  channel?: ConversationChannel;
  /**
   * @deprecated This property exists for historical compatibility.  Use subjectParticipantsKey instead.
   */
  accountGroupId?: string;
  /**
   * @deprecated This property exists for historical compatibility.  Use subjectParticipantsKey instead.
   */
  partnerId?: string;
  /**
   * @deprecated This property exists for historical compatibility. Use subjectParticipantsKey instead.
   */
  vendorPartnerId?: string;
  latestMsgSentTime?: Timestamp;
  created?: Timestamp;
  deleted?: Timestamp;
  updated?: Timestamp;
  /**
   * @deprecated This property exists for historical compatibility
   */
  lastSeen?: Timestamp | null;
  lastSeenByParticipants?: Array<FirestoreLastSeenByParticipant>;
  conversationViewIds?: Array<string>;
}

export interface ConversationMessage {
  id?: string;
  conversationId?: string;
  messageId?: string;
  externalMessageId?: string;
  sender?: Participant;
  type: MessageType;
  channel: ConversationChannel;
  body?: string;
  media?: Media[];
  sendStatus?: SendStatusInterface;
  created?: Date;
  deleted?: Date;
  updated?: Date;
}

export interface ConversationEvent {
  conversationId: string;
  eventId: string;
  happenedAt: Timestamp;
  labelKey: string;
  initiator?: string;
  message?: string;
  created: Timestamp;
  updated: Timestamp;
  deleted: Timestamp;
}

export interface ConversationUnseen {
  conversationId?: string;
  read: boolean;
}

export interface FirestoreLastSeenByParticipant {
  participantId?: string;
  lastSeenTime?: Timestamp;
}

export interface ConversationBadge {
  participantType: string;
  badgeColor: BadgeColor;
}
export type ConversationDetail = GetMultiConversationDetailsResponseDetailedConversation;

export interface ConversationDetailCache {
  [conversationId: string]: ConversationDetail;
}

export interface SendMessage {
  participants?: Array<Participant>;
  location: PlatformLocation;
  channel: ConversationChannel;
}

export interface ConversationTitleInfo {
  title: string;
  subtitle?: string;
  secondarySubtitle?: string;
}

export interface ConversationRecipientInfo {
  id: string;
  type: ParticipantType;
}

export interface KabobDynamicButton {
  title: string;
  action: () => void;
  posthogLabel: string;
}

export interface TermsOfServiceResult {
  termsOfServiceTextMessage: string;
  termsOfServiceAccepted: boolean;
}

export interface Media {
  mediaUrl: string;
  mediaContentType: string;
  mediaFileName: string;
  mediaLocationPath: string;
  fileSize?: number;
}

export function convertMediaJSONIntoMedia(media: string): Media | null {
  if (!media) {
    return null;
  }
  const data = JSON.parse(media);
  return {
    mediaUrl: data.MediaUrl,
    mediaContentType: data.MediaContentType,
    mediaFileName: data.MediaFileName,
    mediaLocationPath: data.MediaLocationPath,
    fileSize: data.FileSize,
  };
}

export interface MessageInfo {
  text: string;
  channel: ConversationChannel;
  attachments: MediaInterface[];
}

export interface ConversationAvailableChannels {
  availableChannels: ConversationChannel[];
  preferredChannel: ConversationChannel;
}
